import { render, staticRenderFns } from "./Demand.vue?vue&type=template&id=3e12fa1a&scoped=true"
import script from "./Demand.vue?vue&type=script&lang=js"
export * from "./Demand.vue?vue&type=script&lang=js"
import style0 from "./Demand.vue?vue&type=style&index=0&id=3e12fa1a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e12fa1a",
  null
  
)

export default component.exports